// extracted by mini-css-extract-plugin
export default {"container":"SideSection_container__8XfSe","logoContainer":"SideSection_logoContainer__+eqKS","active":"SideSection_active__xLpPr"};